import styled from '@emotion/styled';

export const MapSplashBg = styled.div`
    height: 100%;
    background: url('/assets/map-manager/map-bg.png');
    background-size: cover;
    background-repeat: no-repeat;
`;
